import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { IsauthorizedService } from '../services/isauthorized.service';

@Injectable()
export class UploadBulkOrderGuard  {

  constructor(
    private router: Router, private isAuthorizedService: IsauthorizedService) {
  }

  canActivate(): Observable<boolean> | boolean {
    if (this.isAuthorizedService.checkControlAuthorization('subTabCreateBulkOrders')) {
      return true;
    }
    this.router.navigate(['/'], { replaceUrl: true });
  }


  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.isAuthorizedService.checkControlAuthorization('subTabCreateBulkOrders')) {
      return true;
    }
    this.router.navigate(['/'], { replaceUrl: true });
  }
}
